import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Identity, IdentityStorage } from 'storage-service-lib';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styles: ['header { transition: all .5s; }'],
    standalone: false
})
export class HeaderComponent implements OnDestroy {
  identity: Identity;

  private identitySubscription: Subscription;

  constructor(private identityStorage: IdentityStorage) {
    this.identitySubscription = identityStorage
      .observe()
      .pipe(debounceTime(250)) // prevents the UI from jumping around - TODO: AJ take a look at
      .subscribe(() => {
        this.identity = identityStorage.get();
      });
  }

  ngOnDestroy(): void {
    this.identitySubscription.unsubscribe();
  }
}
